import { Extraction } from "../../api/types";

export enum enumExtractionKey {
  PURCHASE_ORDER = "Purchase Order",
  INVOICE = "Invoice",
  BILL_OF_LADING = "Bill of Lading",
  PICK_PACK_LIST = "Pick Pack List",
}

export const extractions: { [key: string]: Extraction } = {
  [enumExtractionKey.INVOICE]: {
    id: "6615e4a4-3d3c-41fe-b13b-a473a861e9f0",
    workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
    status: "complete",
    error: null,
    metadata: {
      name: "Invoice Template  1.pdf",
    },
    schema_id: "2c50ab7e-994a-4e7f-afc3-87b63ac371c0",
    file_name: "Invoice Template  1.pdf",
    file_type: "application/pdf",
    file_size: 814303,
    template: [
      {
        name: "Customer Name",
        key: "customer_name",
        data_type: "string",
        description: "Customer name. This can be a personal or business name. The customer can be who the invoice is addressed to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Customer Address Full",
        key: "customer_address_full",
        data_type: "string",
        description: "Full customer address. The customer is whom the invoice is addressed or billed to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Customer Address Street",
        key: "customer_address_street",
        data_type: "string",
        description:
          "Street number and name of the customer address. The customer address is the address to whom the invoice is addressed or billed to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Customer Address City State",
        key: "customer_address_city_state",
        data_type: "string",
        description: "City and state of the customer address. The customer address is the address to whom the invoice is addressed or billed to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Customer Address Zip Code",
        key: "customer_address_zip_code",
        data_type: "string",
        description: "Zip code of the customer address. The customer address is the address to whom the invoice is addressed or billed to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Customer Email",
        key: "customer_email",
        data_type: "string",
        description: "Customer's email address. The customer can be who the invoice is addressed to",
        default_value: "",
        validations: [
          {
            id: 128,
            validate: "email",
            options: null,
            severity: "error",
            message: "The cell must be a valid email",
          },
        ],
        transformers: [],
      },
      {
        name: "Customer Phone",
        key: "customer_phone",
        data_type: "string",
        description: "Customer's phone number. The customer can be who the invoice is addressed to",
        default_value: "",
        validations: [
          {
            id: 129,
            validate: "phone",
            options: null,
            severity: "error",
            message: "The cell must be a valid phone number",
          },
        ],
        transformers: [],
      },
      {
        name: "Billing Date",
        key: "billing_date",
        data_type: "date",
        description: "The billing date of the invoice",
        default_value: "",
        validations: [
          {
            id: 92,
            validate: "date",
            options: null,
            severity: "error",
            message: "The cell must be a date",
          },
        ],
        transformers: [],
      },
      {
        name: "Due Date",
        key: "due_date",
        data_type: "date",
        description: "Due date",
        default_value: "",
        validations: [
          {
            id: 116,
            validate: "date",
            options: null,
            severity: "error",
            message: "The cell must be a date",
          },
        ],
        transformers: [],
      },
      {
        name: "Customer ID",
        key: "customer_id",
        data_type: "string",
        description: "ID of the customer",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Invoice Number",
        key: "invoice_number",
        data_type: "string",
        description: "Invoice number",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Line Items",
        key: "line_items",
        data_type: "table",
        description: "Table containing the invoice line items",
        default_value: "",
        validations: [],
        transformers: [],
        columns: [
          {
            name: "Item Description",
            key: "item_description",
            data_type: "string",
            description: "Description of the item",
            default_value: "",
            validations: [
              {
                id: 169,
                validate: "not_blank",
                options: null,
                severity: "error",
                message: "The cell must contain a value",
              },
            ],
            transformers: [],
          },
          {
            name: "Item Quantity",
            key: "item_quantity",
            data_type: "number",
            description: "Quantity of the line item",
            default_value: "",
            validations: [
              {
                id: 168,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
          {
            name: "Item Unit Price",
            key: "item_unit_price",
            data_type: "number",
            description: "Unit price of the line item",
            default_value: "",
            validations: [
              {
                id: 171,
                validate: "decimal",
                options: null,
                severity: "error",
                message: "The cell must be a decimal",
              },
              {
                id: 172,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
          {
            name: "Item Amount",
            key: "item_amount",
            data_type: "number",
            description: "Amount, in dollars, of the line item. This should be the total cost of this line item, usually quantity * unit price",
            default_value: "",
            validations: [
              {
                id: 173,
                validate: "decimal",
                options: null,
                severity: "error",
                message: "The cell must be a decimal",
              },
              {
                id: 174,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
        ],
      },
      {
        name: "Sub Total",
        key: "sub_total",
        data_type: "number",
        description: "Sub total of the entire invoice",
        default_value: "",
        validations: [
          {
            id: 125,
            validate: "decimal",
            options: null,
            severity: "error",
            message: "The cell must be a decimal",
          },
          {
            id: 126,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
      {
        name: "Tax",
        key: "tax",
        data_type: "number",
        description: "The amount, in dollars, of tax",
        default_value: "",
        validations: [
          {
            id: 89,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
          {
            id: 113,
            validate: "decimal",
            options: null,
            severity: "error",
            message: "The cell must be a decimal",
          },
        ],
        transformers: [],
      },
      {
        name: "Total",
        key: "total",
        data_type: "number",
        description: "The total amount of the entire invoice",
        default_value: "",
        validations: [
          {
            id: 170,
            validate: "decimal",
            options: null,
            severity: "error",
            message: "The cell must be a decimal",
          },
          {
            id: 95,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
    ],
    data: {
      billing_date: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "33dd6a85-32ae-4523-8a99-1f7e27e6a23b",
          type: "LAYOUT_TEXT",
          confidence: 54.58984375,
          bounding_box: {
            width: 0.08572190999984741,
            height: 0.024261053651571274,
            left: 0.11214888840913773,
            top: 0.39257851243019104,
          },
          text: "Billing date 01/01/2024",
        },
        value: "01/01/2024",
        errors: null,
      },
      customer_address_city_state: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6fa75653-b0d7-48bd-94bd-5d5cff1ad619",
          type: "LAYOUT_HEADER",
          confidence: 50.87890625,
          bounding_box: {
            width: 0.18122321367263794,
            height: 0.11193913966417313,
            left: 0.11160927265882492,
            top: 0.07118071615695953,
          },
          text: "Billed to Paul Limpet 300 New Jersey Ave Washington D.C. 20001 (509) 555-0125 paul@example.site.com",
        },
        value: "Washington D.C.",
        errors: null,
      },
      customer_address_full: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6fa75653-b0d7-48bd-94bd-5d5cff1ad619",
          type: "LAYOUT_HEADER",
          confidence: 50.87890625,
          bounding_box: {
            width: 0.18122321367263794,
            height: 0.11193913966417313,
            left: 0.11160927265882492,
            top: 0.07118071615695953,
          },
          text: "Billed to Paul Limpet 300 New Jersey Ave Washington D.C. 20001 (509) 555-0125 paul@example.site.com",
        },
        value: "Paul Limpet 300 New Jersey Ave Washington D.C. 20001",
        errors: null,
      },
      customer_address_street: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6fa75653-b0d7-48bd-94bd-5d5cff1ad619",
          type: "LAYOUT_HEADER",
          confidence: 50.87890625,
          bounding_box: {
            width: 0.18122321367263794,
            height: 0.11193913966417313,
            left: 0.11160927265882492,
            top: 0.07118071615695953,
          },
          text: "Billed to Paul Limpet 300 New Jersey Ave Washington D.C. 20001 (509) 555-0125 paul@example.site.com",
        },
        value: "300 New Jersey Ave",
        errors: null,
      },
      customer_address_zip_code: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6fa75653-b0d7-48bd-94bd-5d5cff1ad619",
          type: "LAYOUT_HEADER",
          confidence: 50.87890625,
          bounding_box: {
            width: 0.18122321367263794,
            height: 0.11193913966417313,
            left: 0.11160927265882492,
            top: 0.07118071615695953,
          },
          text: "Billed to Paul Limpet 300 New Jersey Ave Washington D.C. 20001 (509) 555-0125 paul@example.site.com",
        },
        value: "20001",
        errors: null,
      },
      customer_email: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6fa75653-b0d7-48bd-94bd-5d5cff1ad619",
          type: "LAYOUT_HEADER",
          confidence: 50.87890625,
          bounding_box: {
            width: 0.18122321367263794,
            height: 0.11193913966417313,
            left: 0.11160927265882492,
            top: 0.07118071615695953,
          },
          text: "Billed to Paul Limpet 300 New Jersey Ave Washington D.C. 20001 (509) 555-0125 paul@example.site.com",
        },
        value: "paul@example.site.com",
        errors: null,
      },
      customer_id: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "9a473d81-d4f0-4477-9286-cc1fac9b4119",
          type: "LAYOUT_TEXT",
          confidence: 50.48828125,
          bounding_box: {
            width: 0.0956103727221489,
            height: 0.02307341992855072,
            left: 0.11204518377780914,
            top: 0.4713873863220215,
          },
          text: "Customer ID 029-123456",
        },
        value: "029-123456",
        errors: null,
      },
      customer_name: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6fa75653-b0d7-48bd-94bd-5d5cff1ad619",
          type: "LAYOUT_HEADER",
          confidence: 50.87890625,
          bounding_box: {
            width: 0.18122321367263794,
            height: 0.11193913966417313,
            left: 0.11160927265882492,
            top: 0.07118071615695953,
          },
          text: "Billed to Paul Limpet 300 New Jersey Ave Washington D.C. 20001 (509) 555-0125 paul@example.site.com",
        },
        value: "Paul Limpet",
        errors: null,
      },
      customer_phone: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6fa75653-b0d7-48bd-94bd-5d5cff1ad619",
          type: "LAYOUT_HEADER",
          confidence: 50.87890625,
          bounding_box: {
            width: 0.18122321367263794,
            height: 0.11193913966417313,
            left: 0.11160927265882492,
            top: 0.07118071615695953,
          },
          text: "Billed to Paul Limpet 300 New Jersey Ave Washington D.C. 20001 (509) 555-0125 paul@example.site.com",
        },
        value: "(509) 555-0125",
        errors: null,
      },
      due_date: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "a22b74aa-2b68-4219-bc2b-ff6dd32217db",
          type: "LAYOUT_TEXT",
          confidence: 53.61328125,
          bounding_box: {
            width: 0.08496269583702087,
            height: 0.024013813585042953,
            left: 0.11218488216400146,
            top: 0.43212008476257324,
          },
          text: "Due date 02/01/2024",
        },
        value: "02/01/2024",
        errors: null,
      },
      invoice_number: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "1ef1e3b8-7da4-4a88-a511-99f71dbfe91c",
          type: "LAYOUT_TEXT",
          confidence: 46.58203125,
          bounding_box: {
            width: 0.0884646624326706,
            height: 0.023322168737649918,
            left: 0.1115715503692627,
            top: 0.5113943815231323,
          },
          text: "Invoice # 072-654321",
        },
        value: "072-654321",
        errors: null,
      },
      line_items: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "6671af72-f5cd-47e5-af53-3b8f735668fb",
          type: "LAYOUT_TABLE",
          confidence: 51.85546875,
          bounding_box: {
            width: 0.6446505188941956,
            height: 0.15185849368572235,
            left: 0.24297720193862915,
            top: 0.39183783531188965,
          },
          text: 'DESCRIPTION\tQUANTITY\tUNIT PRICE\tAMOUNT\n1/4"-20 Camera Mounting Screws\t40\t14.99\t599.60\n(50-pack)\nC-Stand with 40" Arm and Grip Head\t15\t129.99\t1,949.85\nXLR Cable 25ft - Neutrik Connectors\t50\t29.99\t1,499.50\n3-Pin DMX Cable 25ft\t40\t27.99\t1,119.60\nSpring Clamp 4" (6-pack)\t50\t12.99\t649.50',
        },
        value: null,
        errors: null,
        table_data: [
          {
            item_amount: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "599.6",
              errors: null,
            },
            item_description: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: '1/4"-20 Camera Mounting Screws (50-pack)',
              errors: null,
            },
            item_quantity: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "40",
              errors: null,
            },
            item_unit_price: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "14.99",
              errors: null,
            },
          },
          {
            item_amount: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "1949.85",
              errors: null,
            },
            item_description: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: 'C-Stand with 40" Arm and Grip Head',
              errors: null,
            },
            item_quantity: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "15",
              errors: null,
            },
            item_unit_price: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "129.99",
              errors: null,
            },
          },
          {
            item_amount: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "1499.5",
              errors: null,
            },
            item_description: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "XLR Cable 25ft - Neutrik Connectors",
              errors: null,
            },
            item_quantity: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "50",
              errors: null,
            },
            item_unit_price: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "29.99",
              errors: null,
            },
          },
          {
            item_amount: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "1119.6",
              errors: null,
            },
            item_description: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "3-Pin DMX Cable 25ft",
              errors: null,
            },
            item_quantity: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "40",
              errors: null,
            },
            item_unit_price: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "27.99",
              errors: null,
            },
          },
          {
            item_amount: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "649.5",
              errors: null,
            },
            item_description: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: 'Spring Clamp 4" (6-pack)',
              errors: null,
            },
            item_quantity: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "50",
              errors: null,
            },
            item_unit_price: {
              page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
              page_number: 1,
              value: "12.99",
              errors: null,
            },
          },
        ],
      },
      sub_total: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "5030c945-c01f-44ac-a378-ff3bb074884d",
          type: "LAYOUT_TABLE",
          confidence: 68.603515625,
          bounding_box: {
            width: 0.32893598079681396,
            height: 0.07124511897563934,
            left: 0.5594480037689209,
            top: 0.5815461874008179,
          },
          text: "Subtotal\t$5,818.05\nTax\t$385.45\nTOTAL\t$6,203.50",
        },
        value: "5818.05",
        errors: null,
      },
      tax: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "5030c945-c01f-44ac-a378-ff3bb074884d",
          type: "LAYOUT_TABLE",
          confidence: 68.603515625,
          bounding_box: {
            width: 0.32893598079681396,
            height: 0.07124511897563934,
            left: 0.5594480037689209,
            top: 0.5815461874008179,
          },
          text: "Subtotal\t$5,818.05\nTax\t$385.45\nTOTAL\t$6,203.50",
        },
        value: "385.45",
        errors: null,
      },
      total: {
        page_id: "befc2197-cd3a-4a04-9c6c-fd3c0c432154",
        page_number: 1,
        page_element: {
          id: "5030c945-c01f-44ac-a378-ff3bb074884d",
          type: "LAYOUT_TABLE",
          confidence: 68.603515625,
          bounding_box: {
            width: 0.32893598079681396,
            height: 0.07124511897563934,
            left: 0.5594480037689209,
            top: 0.5815461874008179,
          },
          text: "Subtotal\t$5,818.05\nTax\t$385.45\nTOTAL\t$6,203.50",
        },
        value: "6203.5",
        errors: null,
      },
    },
    created_at: 1729293008,
    updated_at: 1729293035,
    schema: {
      id: "2c50ab7e-994a-4e7f-afc3-87b63ac371c0",
      workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
      name: "PDF Invoice",
      created_at: 1718664663,
      updated_at: 1718664663,
    },
  },
  [enumExtractionKey.PURCHASE_ORDER]: {
    id: "c58831b1-eb34-49d4-a7d4-eed380f9d56e",
    workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
    status: "complete",
    error: null,
    metadata: {
      name: "Test Purchase Order",
    },
    schema_id: "64700032-d069-4ace-9c56-020b9e8b1a1c",
    file_name: "Purchase Order Example.pdf",
    file_type: "application/pdf",
    file_size: 42694,
    template: [
      {
        name: "Shipping Receiver Name",
        key: "shipping_receiver_name",
        data_type: "string",
        description: "Name of the person to ship to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Shipping Company Name",
        key: "shipping_company_name",
        data_type: "string",
        description: "Name of the company to ship to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Shipping Address",
        key: "shipping_address",
        data_type: "string",
        description: "Ship to address without the company name, person's name, or phone number",
        default_value: "",
        validations: [
          {
            id: 141,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Shipping Phone",
        key: "shipping_phone",
        data_type: "string",
        description: "Shipping or ship to phone number",
        default_value: "",
        validations: [
          {
            id: 142,
            validate: "phone",
            options: null,
            severity: "error",
            message: "The cell must be a valid phone number",
          },
        ],
        transformers: [],
      },
      {
        name: "Shipping Courier",
        key: "shipping_courier",
        data_type: "string",
        description: "Ship via courier name",
        default_value: "",
        validations: [
          {
            id: 149,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Shipping Terms",
        key: "shipping_terms",
        data_type: "string",
        description: "Shipping terms (i.e. NT30)",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Vendor Name",
        key: "vendor_name",
        data_type: "string",
        description: "Vendor name. Can be a company or personal name",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Vendor Address",
        key: "vendor_address",
        data_type: "string",
        description: "Vendor address without the person's name, company name, or phone number",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Vendor Phone",
        key: "vendor_phone",
        data_type: "string",
        description: "Vendor phone number",
        default_value: "",
        validations: [
          {
            id: 143,
            validate: "phone",
            options: null,
            severity: "error",
            message: "The cell must be a valid phone number",
          },
        ],
        transformers: [],
      },
      {
        name: "Vendor Fax",
        key: "vendor_fax",
        data_type: "string",
        description: "Vendor fax number",
        default_value: "",
        validations: [
          {
            id: 144,
            validate: "phone",
            options: null,
            severity: "error",
            message: "The cell must be a valid phone number",
          },
        ],
        transformers: [],
      },
      {
        name: "PO Number",
        key: "po_number",
        data_type: "number",
        description: "Purchase order number. Often found after PO",
        default_value: "",
        validations: [
          {
            id: 102,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
      {
        name: "Order Date",
        key: "order_date",
        data_type: "date",
        description: "Order date, or date of the purchase order",
        default_value: "",
        validations: [
          {
            id: 98,
            validate: "date",
            options: null,
            severity: "error",
            message: "The cell must be a date",
          },
        ],
        transformers: [],
      },
      {
        name: "Line Items",
        key: "line_items",
        data_type: "table",
        description: "Table of items in the purchase order. Includes data such as item numbers, descriptions, quantities, and prices",
        default_value: "",
        validations: [],
        transformers: [],
        columns: [
          {
            name: "Item Number",
            key: "item_number",
            data_type: "string",
            description: 'Item number, or item #. Often found in the format "XX000"',
            default_value: "",
            validations: [
              {
                id: 150,
                validate: "not_blank",
                options: null,
                severity: "error",
                message: "The cell must contain a value",
              },
            ],
            transformers: [],
          },
          {
            name: "Item Description",
            key: "item_description",
            data_type: "string",
            description: 'Description of the item, i.e. "Fastener set"',
            default_value: "",
            validations: [],
            transformers: [],
          },
          {
            name: "Item Quantity",
            key: "item_quantity",
            data_type: "number",
            description: "Item quantity, or qty",
            default_value: "",
            validations: [
              {
                id: 136,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
          {
            name: "Item Unit Price",
            key: "item_unit_price",
            data_type: "number",
            description: "Item unit price",
            default_value: "",
            validations: [
              {
                id: 137,
                validate: "decimal",
                options: null,
                severity: "error",
                message: "The cell must be a decimal",
              },
              {
                id: 138,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
          {
            name: "Item Total",
            key: "item_total",
            data_type: "number",
            description: "Item total price",
            default_value: "",
            validations: [
              {
                id: 139,
                validate: "decimal",
                options: null,
                severity: "error",
                message: "The cell must be a decimal",
              },
              {
                id: 140,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
        ],
      },
      {
        name: "Subtotal",
        key: "subtotal",
        data_type: "number",
        description: "Subtotal amount of the purchase order",
        default_value: "",
        validations: [
          {
            id: 145,
            validate: "decimal",
            options: null,
            severity: "error",
            message: "The cell must be a decimal",
          },
          {
            id: 146,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
      {
        name: "Tax",
        key: "tax",
        data_type: "number",
        description: "Tax amount of the purchase order",
        default_value: "",
        validations: [
          {
            id: 147,
            validate: "decimal",
            options: null,
            severity: "error",
            message: "The cell must be a decimal",
          },
          {
            id: 148,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
      {
        name: "Total",
        key: "total",
        data_type: "number",
        description: "Total dollar amount of the purchase order",
        default_value: "",
        validations: [
          {
            id: 107,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
          {
            id: 123,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
          {
            id: 124,
            validate: "decimal",
            options: null,
            severity: "error",
            message: "The cell must be a decimal",
          },
        ],
        transformers: [],
      },
    ],
    data: {
      line_items: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "a55e4d50-0807-4cff-9b69-23ff2c734204",
          type: "LAYOUT_TABLE",
          confidence: 90.72265625,
          bounding_box: {
            width: 0.872103750705719,
            height: 0.08602428436279297,
            left: 0.05442233383655548,
            top: 0.4477555751800537,
          },
          text: "ITEM #\tDESCRIPTION\tQTY\tUNIT PRICE\tTOTAL\nFA003\tFastener Set (500 pcs)\t5\t45.75\t228.75\nRB009\tRubber Gasket Set\t25\t35.00\t875.00\nMF001\tSteel Sheet (4'x8')\t50\t85.00\t4,250.00",
        },
        value: null,
        errors: null,
        table_data: [
          {
            item_description: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "Fastener Set (500 pcs)",
              errors: null,
            },
            item_number: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "FA003",
              errors: null,
            },
            item_quantity: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "5",
              errors: null,
            },
            item_total: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "228.75",
              errors: null,
            },
            item_unit_price: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "45.75",
              errors: null,
            },
          },
          {
            item_description: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "Rubber Gasket Set",
              errors: null,
            },
            item_number: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "RB009",
              errors: null,
            },
            item_quantity: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "25",
              errors: null,
            },
            item_total: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "875",
              errors: null,
            },
            item_unit_price: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "35",
              errors: null,
            },
          },
          {
            item_description: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "Steel Sheet (4'x8')",
              errors: null,
            },
            item_number: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "MF001",
              errors: null,
            },
            item_quantity: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "50",
              errors: null,
            },
            item_total: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "4250",
              errors: null,
            },
            item_unit_price: {
              page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
              page_number: 1,
              value: "85",
              errors: null,
            },
          },
        ],
      },
      order_date: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "6e54fb8e-66e6-40e6-87e0-ad039ab55ba6",
          type: "LAYOUT_TEXT",
          confidence: 67.041015625,
          bounding_box: {
            width: 0.07503185421228409,
            height: 0.029236339032649994,
            left: 0.8185828328132629,
            top: 0.10015459358692169,
          },
          text: "9/29/2024 123456",
        },
        value: "09/29/2024",
        errors: null,
      },
      po_number: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "6e54fb8e-66e6-40e6-87e0-ad039ab55ba6",
          type: "LAYOUT_TEXT",
          confidence: 67.041015625,
          bounding_box: {
            width: 0.07503185421228409,
            height: 0.029236339032649994,
            left: 0.8185828328132629,
            top: 0.10015459358692169,
          },
          text: "9/29/2024 123456",
        },
        value: "123456",
        errors: null,
      },
      shipping_address: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "b85470fe-ce2f-43db-8fdb-0f5ab6f509d0",
          type: "LAYOUT_TEXT",
          confidence: 94.775390625,
          bounding_box: {
            width: 0.14784660935401917,
            height: 0.10904467105865479,
            left: 0.5501800775527954,
            top: 0.21718193590641022,
          },
          text: "SHIP TO Jane Smith Western Imports LTD 456 North Ave Madison, WI 53558 (608) 555-2291",
        },
        value: "456 North Ave Madison, WI 53558",
        errors: null,
      },
      shipping_company_name: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "b85470fe-ce2f-43db-8fdb-0f5ab6f509d0",
          type: "LAYOUT_TEXT",
          confidence: 94.775390625,
          bounding_box: {
            width: 0.14784660935401917,
            height: 0.10904467105865479,
            left: 0.5501800775527954,
            top: 0.21718193590641022,
          },
          text: "SHIP TO Jane Smith Western Imports LTD 456 North Ave Madison, WI 53558 (608) 555-2291",
        },
        value: "Western Imports LTD",
        errors: null,
      },
      shipping_courier: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "e1f67f6d-a69a-4644-b7a4-6cbb9ed7a9d7",
          type: "LAYOUT_TABLE",
          confidence: 85.44921875,
          bounding_box: {
            width: 0.8724024891853333,
            height: 0.05257757008075714,
            left: 0.05468883365392685,
            top: 0.37364694476127625,
          },
          text: "REQUISITIONER\tSHIP VIA\tF.O.B.\tSHIPPING TERMS\nDan Johnson\tFedEx Ground\tDestination\tNT30",
        },
        value: "FedEx Ground",
        errors: null,
      },
      shipping_phone: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "b85470fe-ce2f-43db-8fdb-0f5ab6f509d0",
          type: "LAYOUT_TEXT",
          confidence: 94.775390625,
          bounding_box: {
            width: 0.14784660935401917,
            height: 0.10904467105865479,
            left: 0.5501800775527954,
            top: 0.21718193590641022,
          },
          text: "SHIP TO Jane Smith Western Imports LTD 456 North Ave Madison, WI 53558 (608) 555-2291",
        },
        value: "(608) 555-2291",
        errors: null,
      },
      shipping_receiver_name: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "b85470fe-ce2f-43db-8fdb-0f5ab6f509d0",
          type: "LAYOUT_TEXT",
          confidence: 94.775390625,
          bounding_box: {
            width: 0.14784660935401917,
            height: 0.10904467105865479,
            left: 0.5501800775527954,
            top: 0.21718193590641022,
          },
          text: "SHIP TO Jane Smith Western Imports LTD 456 North Ave Madison, WI 53558 (608) 555-2291",
        },
        value: "Jane Smith",
        errors: null,
      },
      shipping_terms: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "e1f67f6d-a69a-4644-b7a4-6cbb9ed7a9d7",
          type: "LAYOUT_TABLE",
          confidence: 85.44921875,
          bounding_box: {
            width: 0.8724024891853333,
            height: 0.05257757008075714,
            left: 0.05468883365392685,
            top: 0.37364694476127625,
          },
          text: "REQUISITIONER\tSHIP VIA\tF.O.B.\tSHIPPING TERMS\nDan Johnson\tFedEx Ground\tDestination\tNT30",
        },
        value: "NT30",
        errors: null,
      },
      subtotal: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "b1de44dc-0687-49e7-9bcc-7c9444017124",
          type: "LAYOUT_TABLE",
          confidence: 63.720703125,
          bounding_box: {
            width: 0.26262715458869934,
            height: 0.11485469341278076,
            left: 0.6645254492759705,
            top: 0.5908498167991638,
          },
          text: "SUBTOTAL\t5353.75\nTAX\t267.68\nSHIPPING\nOTHER\nTOTAL\t$5621.43",
        },
        value: "5353.75",
        errors: null,
      },
      tax: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "b1de44dc-0687-49e7-9bcc-7c9444017124",
          type: "LAYOUT_TABLE",
          confidence: 63.720703125,
          bounding_box: {
            width: 0.26262715458869934,
            height: 0.11485469341278076,
            left: 0.6645254492759705,
            top: 0.5908498167991638,
          },
          text: "SUBTOTAL\t5353.75\nTAX\t267.68\nSHIPPING\nOTHER\nTOTAL\t$5621.43",
        },
        value: "267.68",
        errors: null,
      },
      total: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "b1de44dc-0687-49e7-9bcc-7c9444017124",
          type: "LAYOUT_TABLE",
          confidence: 63.720703125,
          bounding_box: {
            width: 0.26262715458869934,
            height: 0.11485469341278076,
            left: 0.6645254492759705,
            top: 0.5908498167991638,
          },
          text: "SUBTOTAL\t5353.75\nTAX\t267.68\nSHIPPING\nOTHER\nTOTAL\t$5621.43",
        },
        value: "5621.43",
        errors: null,
      },
      vendor_address: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "cd6df832-69b7-4328-b57a-f8a8d4221c19",
          type: "LAYOUT_TEXT",
          confidence: 91.2109375,
          bounding_box: {
            width: 0.19417819380760193,
            height: 0.10587745159864426,
            left: 0.06467672437429428,
            top: 0.23888175189495087,
          },
          text: "TechPro Industrial Supplies Attn: Sales Department 1234 Innovation Drive San Jose, CA 95134 Phone: (408) 555-7890 Fax: (408) 555-7891",
        },
        value: "1234 Innovation Drive San Jose, CA 95134",
        errors: null,
      },
      vendor_fax: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "cd6df832-69b7-4328-b57a-f8a8d4221c19",
          type: "LAYOUT_TEXT",
          confidence: 91.2109375,
          bounding_box: {
            width: 0.19417819380760193,
            height: 0.10587745159864426,
            left: 0.06467672437429428,
            top: 0.23888175189495087,
          },
          text: "TechPro Industrial Supplies Attn: Sales Department 1234 Innovation Drive San Jose, CA 95134 Phone: (408) 555-7890 Fax: (408) 555-7891",
        },
        value: "(408) 555-7891",
        errors: null,
      },
      vendor_name: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "cd6df832-69b7-4328-b57a-f8a8d4221c19",
          type: "LAYOUT_TEXT",
          confidence: 91.2109375,
          bounding_box: {
            width: 0.19417819380760193,
            height: 0.10587745159864426,
            left: 0.06467672437429428,
            top: 0.23888175189495087,
          },
          text: "TechPro Industrial Supplies Attn: Sales Department 1234 Innovation Drive San Jose, CA 95134 Phone: (408) 555-7890 Fax: (408) 555-7891",
        },
        value: "TechPro Industrial Supplies",
        errors: null,
      },
      vendor_phone: {
        page_id: "8e2d6e1b-0d72-466a-90b4-91bd0f61ef0a",
        page_number: 1,
        page_element: {
          id: "cd6df832-69b7-4328-b57a-f8a8d4221c19",
          type: "LAYOUT_TEXT",
          confidence: 91.2109375,
          bounding_box: {
            width: 0.19417819380760193,
            height: 0.10587745159864426,
            left: 0.06467672437429428,
            top: 0.23888175189495087,
          },
          text: "TechPro Industrial Supplies Attn: Sales Department 1234 Innovation Drive San Jose, CA 95134 Phone: (408) 555-7890 Fax: (408) 555-7891",
        },
        value: "(408) 555-7890",
        errors: null,
      },
    },
    created_at: 1729015100,
    updated_at: 1729015122,
    schema: {
      id: "64700032-d069-4ace-9c56-020b9e8b1a1c",
      workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
      name: "PDF Purchase Order",
      created_at: 1726612373,
      updated_at: 1726612373,
    },
  },
  [enumExtractionKey.BILL_OF_LADING]: {
    id: "40985606-6921-4189-9eb2-1896af427765",
    workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
    status: "complete",
    error: null,
    metadata: {
      name: "Bill of Lading Example.pdf",
    },
    schema_id: "e2092c4d-3554-4109-abd2-e734c0169eef",
    file_name: "Bill of Lading Example.pdf",
    file_type: "application/pdf",
    file_size: 323131,
    template: [
      {
        name: "Date",
        key: "date",
        data_type: "date",
        description: "Date of the bill of lading",
        default_value: "",
        validations: [
          {
            id: 185,
            validate: "date",
            options: null,
            severity: "error",
            message: "The cell must be a date",
          },
        ],
        transformers: [],
      },
      {
        name: "Ship From Name",
        key: "ship_from_name",
        data_type: "string",
        description: "Ship from name, not including the address",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Ship From Address",
        key: "ship_from_address",
        data_type: "string",
        description: "Ship from address, just the street name and number",
        default_value: "",
        validations: [
          {
            id: 186,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Ship From City State",
        key: "ship_from_city_state",
        data_type: "string",
        description: "Ship from address city and state, not including the zip code",
        default_value: "",
        validations: [
          {
            id: 187,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Ship From Zip",
        key: "ship_from_zip",
        data_type: "string",
        description: "Zip code of the ship from address",
        default_value: "",
        validations: [
          {
            id: 188,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Ship To Name",
        key: "ship_to_name",
        data_type: "string",
        description: "Ship to name",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Ship To Address",
        key: "ship_to_address",
        data_type: "string",
        description: "Ship to address, just the street name and number",
        default_value: "",
        validations: [
          {
            id: 189,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Ship To City State",
        key: "ship_to_city_state",
        data_type: "string",
        description: "Ship to address city and state, not including the zip code",
        default_value: "",
        validations: [
          {
            id: 190,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Ship To Zip",
        key: "ship_to_zip",
        data_type: "string",
        description: "Zip code of the ship to address",
        default_value: "",
        validations: [
          {
            id: 191,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Bill of Lading Number",
        key: "bill_of_lading_number",
        data_type: "number",
        description: "Bill of lading number",
        default_value: "",
        validations: [
          {
            id: 108,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
          {
            id: 192,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Carrier Name",
        key: "carrier_name",
        data_type: "string",
        description: "Carrier name",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Total Quantity",
        key: "total_quantity",
        data_type: "number",
        description: "Total quantity of the items, can be the number of cases. Only include the number",
        default_value: "",
        validations: [
          {
            id: 110,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
      {
        name: "Total Weight",
        key: "total_weight",
        data_type: "number",
        description: "Total weight of the items",
        default_value: "",
        validations: [
          {
            id: 111,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
      {
        name: "Total Weight Unit",
        key: "total_weight_unit",
        data_type: "string",
        description: 'The unit for the total weight, i.e. "LBS", "KGS", etc.',
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Special Instructions",
        key: "special_instructions",
        data_type: "string",
        description: "Special instructions",
        default_value: "",
        validations: [],
        transformers: [],
      },
    ],
    data: {
      bill_of_lading_number: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "9ca4ee53-1203-47b4-a5ad-5f2634f3a62f",
          type: "LAYOUT_TEXT",
          confidence: 41.7724609375,
          bounding_box: {
            width: 0.2447277009487152,
            height: 0.01356547512114048,
            left: 0.5458914041519165,
            top: 0.10536546260118484,
          },
          text: "Bill of Lading Number: BL-76882",
        },
        value: "76882",
        errors: null,
      },
      carrier_name: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "5fbd0f36-dadd-4d37-a971-cfa48778931b",
          type: "LAYOUT_TEXT",
          confidence: 98.72796630859375,
          bounding_box: {
            width: 0.16150934994220734,
            height: 0.0095017459243536,
            left: 0.5455837249755859,
            top: 0.1789178103208542,
          },
          text: "CARRIER NAME: FedEx",
        },
        value: "FedEx",
        errors: null,
      },
      date: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "dfe4d8b7-9a98-455a-9f48-da36490fa537",
          type: "LAYOUT_TEXT",
          confidence: 39.599609375,
          bounding_box: {
            width: 0.12282568216323853,
            height: 0.010862099938094616,
            left: 0.04560035094618797,
            top: 0.07127568125724792,
          },
          text: "Date: 10/24/2024",
        },
        value: "10/24/2024",
        errors: null,
      },
      ship_from_address: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "1234 Innovation Drive",
        errors: null,
      },
      ship_from_city_state: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "San Jose, CA",
        errors: null,
      },
      ship_from_name: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "TechPro Industrial Suplies",
        errors: null,
      },
      ship_from_zip: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "95134",
        errors: null,
      },
      ship_to_address: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "456 North Ave",
        errors: null,
      },
      ship_to_city_state: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "Madison, WI",
        errors: null,
      },
      ship_to_name: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "Jane Smith",
        errors: null,
      },
      ship_to_zip: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "53558",
        errors: null,
      },
      special_instructions: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "74b23d19-8b2d-4878-b527-e21b24a51898",
          type: "LAYOUT_KEY_VALUE",
          confidence: 26.3671875,
          bounding_box: {
            width: 0.47787079215049744,
            height: 0.26774823665618896,
            left: 0.04291946440935135,
            top: 0.10066443681716919,
          },
          text: "Name: TechPro Industrial Suplies\n Address: 1234 Innovation Drive\n City/State/Zip: San Jose, CA 95134\n SID#: 3381\nFOB:\n\nSHIP TO\n\nName: Jane Smith\nLocation #:\n Address: 456 North Ave\n City/State/Zip: Madison, WI 53558\n CID#: 4953\n\nFOB:\n\nTHIRD PARTY FREIGHT CHARGES BILL TO:\n\nName:\n Address:\n\nCity/State/Zip:\n\nSPECIAL INSTRUCTIONS:\n DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        },
        value: "DELIVERY: 10/30/24 @ 630AM - ASN: 2342, CTRL: 5692",
        errors: null,
      },
      total_quantity: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "3c9bfa10-c0a1-4fcb-9b8e-5692de99dcc8",
          type: "LAYOUT_TABLE",
          confidence: 57.177734375,
          bounding_box: {
            width: 0.3926736588478088,
            height: 0.01697575068473816,
            left: 0.035057831555604935,
            top: 0.748199914932251,
          },
          text: 'CARRIER INFORMATION\nHANDLING UNIT\tPACKAGE\tCOMMODITY DESCRIPTION\tLTL ONLY\nQTY\tTYPE\tQTY\tTYPE\tWEIGHT\tH.M.\tCommodities requiring special or additional care or attention in handling or stowing must be so\tmarked and packaged as to ensure safe transportation with ordinary care.\tNMFC #\tCLASS\n(X)\tSee Section 2(e) of NMFC Item 360\n48\tPKG\t5000\tPCE\t242.5\tHex Bolts (Grade 8) 3/8" X 2"\n100\tPKG\t2500\tPCE\t87.2\tFlat Washers 3/8"\nRECEIVING\nSTAMP SPACE\n148\t7500\t329.7 LBS\tGRAND TOTAL',
        },
        value: "7500",
        errors: null,
      },
      total_weight: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "3c9bfa10-c0a1-4fcb-9b8e-5692de99dcc8",
          type: "LAYOUT_TABLE",
          confidence: 57.177734375,
          bounding_box: {
            width: 0.3926736588478088,
            height: 0.01697575068473816,
            left: 0.035057831555604935,
            top: 0.748199914932251,
          },
          text: 'CARRIER INFORMATION\nHANDLING UNIT\tPACKAGE\tCOMMODITY DESCRIPTION\tLTL ONLY\nQTY\tTYPE\tQTY\tTYPE\tWEIGHT\tH.M.\tCommodities requiring special or additional care or attention in handling or stowing must be so\tmarked and packaged as to ensure safe transportation with ordinary care.\tNMFC #\tCLASS\n(X)\tSee Section 2(e) of NMFC Item 360\n48\tPKG\t5000\tPCE\t242.5\tHex Bolts (Grade 8) 3/8" X 2"\n100\tPKG\t2500\tPCE\t87.2\tFlat Washers 3/8"\nRECEIVING\nSTAMP SPACE\n148\t7500\t329.7 LBS\tGRAND TOTAL',
        },
        value: "329.7",
        errors: null,
      },
      total_weight_unit: {
        page_id: "e1f9820f-1f9c-4ecd-b45f-dd8fc6ea71eb",
        page_number: 1,
        page_element: {
          id: "3c9bfa10-c0a1-4fcb-9b8e-5692de99dcc8",
          type: "LAYOUT_TABLE",
          confidence: 57.177734375,
          bounding_box: {
            width: 0.3926736588478088,
            height: 0.01697575068473816,
            left: 0.035057831555604935,
            top: 0.748199914932251,
          },
          text: 'CARRIER INFORMATION\nHANDLING UNIT\tPACKAGE\tCOMMODITY DESCRIPTION\tLTL ONLY\nQTY\tTYPE\tQTY\tTYPE\tWEIGHT\tH.M.\tCommodities requiring special or additional care or attention in handling or stowing must be so\tmarked and packaged as to ensure safe transportation with ordinary care.\tNMFC #\tCLASS\n(X)\tSee Section 2(e) of NMFC Item 360\n48\tPKG\t5000\tPCE\t242.5\tHex Bolts (Grade 8) 3/8" X 2"\n100\tPKG\t2500\tPCE\t87.2\tFlat Washers 3/8"\nRECEIVING\nSTAMP SPACE\n148\t7500\t329.7 LBS\tGRAND TOTAL',
        },
        value: "LBS",
        errors: null,
      },
    },
    created_at: 1729624983,
    updated_at: 1729625010,
    schema: {
      id: "e2092c4d-3554-4109-abd2-e734c0169eef",
      workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
      name: "PDF Bill of Lading",
      created_at: 1727053242,
      updated_at: 1727053242,
    },
  },
  [enumExtractionKey.PICK_PACK_LIST]: {
    id: "e4a81a78-ddf2-4c4f-bb5e-8b595b926dc9",
    workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
    status: "complete",
    error: null,
    metadata: {
      name: "Pick Pack Slip Example.pdf",
    },
    schema_id: "7a50d834-ab35-4476-802a-409d998c7964",
    file_name: "Pick Pack Slip Example.pdf",
    file_type: "application/pdf",
    file_size: 294826,
    template: [
      {
        name: "Shipping Receiver Name",
        key: "shipping_receiver_name",
        data_type: "string",
        description: "Name of the person to ship to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Shipping Company Name",
        key: "shipping_company_name",
        data_type: "string",
        description: "Name of the company to ship to",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Shipping Address",
        key: "shipping_address",
        data_type: "string",
        description: "Ship to address without the company name, person's name, or phone number",
        default_value: "",
        validations: [
          {
            id: 175,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Pick/Pack Slip Number",
        key: "pick_pack_slip_number",
        data_type: "string",
        description: "Pick/pack slip (PPS) number",
        default_value: "",
        validations: [
          {
            id: 176,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "Pick/Pack Slip Batch Number",
        key: "pick_pack_slip_batch_number",
        data_type: "string",
        description: "Pick/pack slip (PPS) batch number",
        default_value: "",
        validations: [
          {
            id: 177,
            validate: "not_blank",
            options: null,
            severity: "error",
            message: "The cell must contain a value",
          },
        ],
        transformers: [],
      },
      {
        name: "From Warehouse",
        key: "from_warehouse",
        data_type: "string",
        description: "From warehouse",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Transfer Number",
        key: "transfer_number",
        data_type: "string",
        description: "Transfer number",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Required Ship Date",
        key: "required_ship_date",
        data_type: "date",
        description: "Required shipping date",
        default_value: "",
        validations: [
          {
            id: 178,
            validate: "date",
            options: null,
            severity: "error",
            message: "The cell must be a date",
          },
        ],
        transformers: [],
      },
      {
        name: "Total Weight",
        key: "total_weight",
        data_type: "number",
        description: "Total weight (usually in lbs)",
        default_value: "",
        validations: [
          {
            id: 179,
            validate: "decimal",
            options: null,
            severity: "error",
            message: "The cell must be a decimal",
          },
          {
            id: 180,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
      {
        name: "Customer PO Number",
        key: "customer_po_number",
        data_type: "string",
        description: "Customer PO number",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Shipping Courier",
        key: "shipping_courier",
        data_type: "string",
        description: "Shipping courier company name (ship via)",
        default_value: "",
        validations: [],
        transformers: [],
      },
      {
        name: "Line Items",
        key: "line_items",
        data_type: "table",
        description: "Table of items to be packed. Includes data such as line numbers, descriptions, sizes, item numbers, and quantities.\n",
        default_value: "",
        validations: [],
        transformers: [],
        columns: [
          {
            name: "Line #",
            key: "line_number",
            data_type: "number",
            description: "Line number of the item",
            default_value: "",
            validations: [
              {
                id: 181,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
          {
            name: "Description",
            key: "line_item_description",
            data_type: "string",
            description: "Item description",
            default_value: "",
            validations: [],
            transformers: [],
          },
          {
            name: "Size",
            key: "line_item_size",
            data_type: "string",
            description: "Item size",
            default_value: "",
            validations: [],
            transformers: [],
          },
          {
            name: "UOM",
            key: "line_item_uom",
            data_type: "string",
            description: "Item UOM (unit of measurement)",
            default_value: "",
            validations: [],
            transformers: [],
          },
          {
            name: "Amount",
            key: "line_item_pack_amount",
            data_type: "number",
            description: "Item pack size/amount. This is the number of individual units in a package for this item",
            default_value: "",
            validations: [
              {
                id: 182,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
          {
            name: "Item Number",
            key: "line_item_number",
            data_type: "string",
            description: "Item number (not the line number)",
            default_value: "",
            validations: [],
            transformers: [],
          },
          {
            name: "Quantity",
            key: "line_item_quantity",
            data_type: "number",
            description: "Item quantity",
            default_value: "",
            validations: [
              {
                id: 183,
                validate: "number",
                options: null,
                severity: "error",
                message: "The cell must be a number",
              },
            ],
            transformers: [],
          },
        ],
      },
      {
        name: "Total Quantity",
        key: "total_quantity",
        data_type: "number",
        description: "Total quantity of all line items",
        default_value: "",
        validations: [
          {
            id: 184,
            validate: "number",
            options: null,
            severity: "error",
            message: "The cell must be a number",
          },
        ],
        transformers: [],
      },
    ],
    data: {
      customer_po_number: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "16548156-1cb1-4c21-9b78-e8ac942e2be0",
          type: "LAYOUT_TEXT",
          confidence: 50,
          bounding_box: {
            width: 0.031184963881969452,
            height: 0.008401780389249325,
            left: 0.5844336748123169,
            top: 0.24358920753002167,
          },
          text: "1234",
        },
        value: "1234",
        errors: null,
      },
      from_warehouse: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "beff58b1-98fa-4656-ae32-f617f6d9fda5",
          type: "LAYOUT_TABLE",
          confidence: 25.1953125,
          bounding_box: {
            width: 0.5100808143615723,
            height: 0.08060318976640701,
            left: 0.46452924609184265,
            top: 0.14547418057918549,
          },
          text: "PPS NO.\t123456\tPPS BATCH\t987654\nFROM WHSE\tMain\tTRANSFER NO.\t5523\nREQ.SHIP DATE\t10/07/2024\tWEIGHT\t31.56\nPRINT TIME\t2024-10-07 12:24:15\tUSER\texample",
        },
        value: "Main",
        errors: null,
      },
      line_items: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "a4ccd973-8aa9-4ce1-8aa3-2dcebf7456c1",
          type: "LAYOUT_TABLE",
          confidence: 66.2109375,
          bounding_box: {
            width: 0.9659676551818848,
            height: 0.13625705909729,
            left: 0.021081572398543358,
            top: 0.2982649505138397,
          },
          text: 'LINE\tITEM DESCRIPTION\tSIZE\tUOM\tPACK\tITEM\tQTY\n1\tHex Bolts (Grade 8)\t3/8"x2"\tPiece\t50\tHB-3820\t200\n2\tFlat Washers\t3/8"\tPiece\t100\tFW-3800\t500\n3\tLock Nuts\t3/8"\tPiece\t50\tLN-3800\t200\n4\tWood Screws (Phillips)\t#8x1.5"\tPiece\t100\tWS-8150\t1000\n5\tDrywall Anchors\t1/4"\tPiece\t25\tDA-2500\t100\n6\tCarriage Bolts\t1/4"x2"\tPiece\t50\tCB-2520\t150\n2150\nTotal Qty\nTO INBOUND WESTERN IMPORTS LTD\nPICK UP BY FRIDAY 10.11.2024',
        },
        value: null,
        errors: null,
        table_data: [
          {
            line_item_description: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Hex Bolts (Grade 8)",
              errors: null,
            },
            line_item_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "HB-3820",
              errors: null,
            },
            line_item_pack_amount: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "50",
              errors: null,
            },
            line_item_quantity: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "200",
              errors: null,
            },
            line_item_size: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: '3/8"x2"',
              errors: null,
            },
            line_item_uom: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Piece",
              errors: null,
            },
            line_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "1",
              errors: null,
            },
          },
          {
            line_item_description: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Flat Washers",
              errors: null,
            },
            line_item_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "FW-3800",
              errors: null,
            },
            line_item_pack_amount: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "100",
              errors: null,
            },
            line_item_quantity: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "500",
              errors: null,
            },
            line_item_size: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: '3/8"',
              errors: null,
            },
            line_item_uom: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Piece",
              errors: null,
            },
            line_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "2",
              errors: null,
            },
          },
          {
            line_item_description: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Lock Nuts",
              errors: null,
            },
            line_item_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "LN-3800",
              errors: null,
            },
            line_item_pack_amount: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "50",
              errors: null,
            },
            line_item_quantity: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "200",
              errors: null,
            },
            line_item_size: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: '3/8"',
              errors: null,
            },
            line_item_uom: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Piece",
              errors: null,
            },
            line_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "3",
              errors: null,
            },
          },
          {
            line_item_description: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Wood Screws (Phillips)",
              errors: null,
            },
            line_item_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "WS-8150",
              errors: null,
            },
            line_item_pack_amount: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "100",
              errors: null,
            },
            line_item_quantity: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "1000",
              errors: null,
            },
            line_item_size: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: '#8x1.5"',
              errors: null,
            },
            line_item_uom: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Piece",
              errors: null,
            },
            line_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "4",
              errors: null,
            },
          },
          {
            line_item_description: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Drywall Anchors",
              errors: null,
            },
            line_item_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "DA-2500",
              errors: null,
            },
            line_item_pack_amount: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "25",
              errors: null,
            },
            line_item_quantity: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "100",
              errors: null,
            },
            line_item_size: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: '1/4"',
              errors: null,
            },
            line_item_uom: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Piece",
              errors: null,
            },
            line_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "5",
              errors: null,
            },
          },
          {
            line_item_description: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Carriage Bolts",
              errors: null,
            },
            line_item_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "CB-2520",
              errors: null,
            },
            line_item_pack_amount: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "50",
              errors: null,
            },
            line_item_quantity: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "150",
              errors: null,
            },
            line_item_size: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: '1/4"x2"',
              errors: null,
            },
            line_item_uom: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "Piece",
              errors: null,
            },
            line_number: {
              page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
              page_number: 1,
              value: "6",
              errors: null,
            },
          },
        ],
      },
      pick_pack_slip_batch_number: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "beff58b1-98fa-4656-ae32-f617f6d9fda5",
          type: "LAYOUT_TABLE",
          confidence: 25.1953125,
          bounding_box: {
            width: 0.5100808143615723,
            height: 0.08060318976640701,
            left: 0.46452924609184265,
            top: 0.14547418057918549,
          },
          text: "PPS NO.\t123456\tPPS BATCH\t987654\nFROM WHSE\tMain\tTRANSFER NO.\t5523\nREQ.SHIP DATE\t10/07/2024\tWEIGHT\t31.56\nPRINT TIME\t2024-10-07 12:24:15\tUSER\texample",
        },
        value: "987654",
        errors: null,
      },
      pick_pack_slip_number: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "beff58b1-98fa-4656-ae32-f617f6d9fda5",
          type: "LAYOUT_TABLE",
          confidence: 25.1953125,
          bounding_box: {
            width: 0.5100808143615723,
            height: 0.08060318976640701,
            left: 0.46452924609184265,
            top: 0.14547418057918549,
          },
          text: "PPS NO.\t123456\tPPS BATCH\t987654\nFROM WHSE\tMain\tTRANSFER NO.\t5523\nREQ.SHIP DATE\t10/07/2024\tWEIGHT\t31.56\nPRINT TIME\t2024-10-07 12:24:15\tUSER\texample",
        },
        value: "123456",
        errors: null,
      },
      required_ship_date: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "beff58b1-98fa-4656-ae32-f617f6d9fda5",
          type: "LAYOUT_TABLE",
          confidence: 25.1953125,
          bounding_box: {
            width: 0.5100808143615723,
            height: 0.08060318976640701,
            left: 0.46452924609184265,
            top: 0.14547418057918549,
          },
          text: "PPS NO.\t123456\tPPS BATCH\t987654\nFROM WHSE\tMain\tTRANSFER NO.\t5523\nREQ.SHIP DATE\t10/07/2024\tWEIGHT\t31.56\nPRINT TIME\t2024-10-07 12:24:15\tUSER\texample",
        },
        value: "10/07/2024",
        errors: null,
      },
      shipping_address: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "85e82231-d816-41d2-b4ff-6f9ab07eed0c",
          type: "LAYOUT_TEXT",
          confidence: 78.662109375,
          bounding_box: {
            width: 0.13351714611053467,
            height: 0.07162723690271378,
            left: 0.040859565138816833,
            top: 0.1785392165184021,
          },
          text: "SHIP TO: Jane Smith Western Imports LTD 456 North Ave Madison, WI 53558",
        },
        value: "456 North Ave Madison, WI 53558",
        errors: null,
      },
      shipping_company_name: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "85e82231-d816-41d2-b4ff-6f9ab07eed0c",
          type: "LAYOUT_TEXT",
          confidence: 78.662109375,
          bounding_box: {
            width: 0.13351714611053467,
            height: 0.07162723690271378,
            left: 0.040859565138816833,
            top: 0.1785392165184021,
          },
          text: "SHIP TO: Jane Smith Western Imports LTD 456 North Ave Madison, WI 53558",
        },
        value: "Western Imports LTD",
        errors: null,
      },
      shipping_courier: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "743dbaed-6372-4758-a7cc-b610482c2e7c",
          type: "LAYOUT_TEXT",
          confidence: 55.37109375,
          bounding_box: {
            width: 0.09206809848546982,
            height: 0.009392784908413887,
            left: 0.5824759602546692,
            top: 0.26078519225120544,
          },
          text: "FedEx Ground",
        },
        value: "FedEx Ground",
        errors: null,
      },
      shipping_receiver_name: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "85e82231-d816-41d2-b4ff-6f9ab07eed0c",
          type: "LAYOUT_TEXT",
          confidence: 78.662109375,
          bounding_box: {
            width: 0.13351714611053467,
            height: 0.07162723690271378,
            left: 0.040859565138816833,
            top: 0.1785392165184021,
          },
          text: "SHIP TO: Jane Smith Western Imports LTD 456 North Ave Madison, WI 53558",
        },
        value: "Jane Smith",
        errors: null,
      },
      total_quantity: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "b4ccd973-8aa9-4ce1-8aa3-2dcebf7456c1",
          type: "LAYOUT_TABLE",
          confidence: 66.2109375,
          bounding_box: {
            width: 0.8659676551818848,
            height: 0.01825705909729,
            left: 0.075081572398543358,
            top: 0.4572649505138397,
          },
          text: 'LINE\tITEM DESCRIPTION\tSIZE\tUOM\tPACK\tITEM\tQTY\n1\tHex Bolts (Grade 8)\t3/8"x2"\tPiece\t50\tHB-3820\t200\n2\tFlat Washers\t3/8"\tPiece\t100\tFW-3800\t500\n3\tLock Nuts\t3/8"\tPiece\t50\tLN-3800\t200\n4\tWood Screws (Phillips)\t#8x1.5"\tPiece\t100\tWS-8150\t1000\n5\tDrywall Anchors\t1/4"\tPiece\t25\tDA-2500\t100\n6\tCarriage Bolts\t1/4"x2"\tPiece\t50\tCB-2520\t150\n2150\nTotal Qty\nTO INBOUND WESTERN IMPORTS LTD\nPICK UP BY FRIDAY 10.11.2024',
        },
        value: "2150",
        errors: null,
      },
      total_weight: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "beff58b1-98fa-4656-ae32-f617f6d9fda5",
          type: "LAYOUT_TABLE",
          confidence: 25.1953125,
          bounding_box: {
            width: 0.5100808143615723,
            height: 0.08060318976640701,
            left: 0.46452924609184265,
            top: 0.14547418057918549,
          },
          text: "PPS NO.\t123456\tPPS BATCH\t987654\nFROM WHSE\tMain\tTRANSFER NO.\t5523\nREQ.SHIP DATE\t10/07/2024\tWEIGHT\t31.56\nPRINT TIME\t2024-10-07 12:24:15\tUSER\texample",
        },
        value: "31.56",
        errors: null,
      },
      transfer_number: {
        page_id: "c56432c8-b8f9-423e-a1b1-d13a61a27c5d",
        page_number: 1,
        page_element: {
          id: "beff58b1-98fa-4656-ae32-f617f6d9fda5",
          type: "LAYOUT_TABLE",
          confidence: 25.1953125,
          bounding_box: {
            width: 0.5100808143615723,
            height: 0.08060318976640701,
            left: 0.46452924609184265,
            top: 0.14547418057918549,
          },
          text: "PPS NO.\t123456\tPPS BATCH\t987654\nFROM WHSE\tMain\tTRANSFER NO.\t5523\nREQ.SHIP DATE\t10/07/2024\tWEIGHT\t31.56\nPRINT TIME\t2024-10-07 12:24:15\tUSER\texample",
        },
        value: "5523",
        errors: null,
      },
    },
    created_at: 1729620803,
    updated_at: 1729620838,
    schema: {
      id: "7a50d834-ab35-4476-802a-409d998c7964",
      workspace_id: "64ebaa43-2f80-4dd5-8f22-9ebfeeebfe2d",
      name: "PDF Pick/Pack Slip",
      created_at: 1729543484,
      updated_at: 1729543484,
    },
  },
} as unknown as { [key: string]: Extraction };
